import { SlotGameType1_21 } from '../SlotGameType1_21';

export class AncientSea3DFillingPot21 extends SlotGameType1_21
{
}
